import { render } from "./OnholdBilledCases.vue?vue&type=template&id=611d7369"
import script from "./OnholdBilledCases.vue?vue&type=script&lang=js"
export * from "./OnholdBilledCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/OnholdBilledCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "611d7369"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('611d7369', __exports__)) {
    console.log('reload')
    api.reload('611d7369', __exports__)
  }
  
  module.hot.accept("./OnholdBilledCases.vue?vue&type=template&id=611d7369", () => {
    console.log('re-render')
    api.rerender('611d7369', render)
  })

}


export default __exports__